import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const CoinComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__coin"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8 8.14393C11.866 8.14393 15 7.09926 15 5.8106C15 4.52193 11.866 3.47726 8 3.47726C4.13401 3.47726 1 4.52193 1 5.8106C1 7.09926 4.13401 8.14393 8 8.14393Z"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 5.81061L1 9.01894C1 10.4714 4.11111 11.6439 8 11.6439C11.8889 11.6439 15 10.4714 15 9.01894V5.81061"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="4.375" y1="8.14392" x2="4.375" y2="11.6439" stroke={colorVar} strokeWidth="1.5" />
      <line x1="7.875" y1="8.14392" x2="7.875" y2="11.6439" stroke={colorVar} strokeWidth="1.5" />
      <line x1="11.375" y1="8.14392" x2="11.375" y2="11.6439" stroke={colorVar} strokeWidth="1.5" />
    </svg>
  );
};

export const Coin = withIcon(CoinComponent);
